import { Button, Typography, TextField } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useState } from "react";
import { FormContainer } from "./styled";
import { useHistory } from "react-router-dom";
import { login } from '../../requests/req_menu';
import { getPerfil } from "../../requests/req_perfil";
import { amb } from '../../requests/utils';

const FrmLogin = ({ active, fncPostula, fncMobile }) => {
  const [frmValues, setFrmValues] = useState({ Correo: '', Password: '' });
  const [errores, setErrores] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const recuperarPassword = () => {
    history.push('/olvidada');
  }

  const submit = async () => {
    setErrores({})
    let errors;
    if (!frmValues.Correo.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      errors = {
        ...errors,
        Correo: 'Ingrese un correo válido'
      };
    }
    if (frmValues.Password.length == 0) {
      errors = {
        ...errors,
        Password: 'Ingrese su contraseña'
      }
    }
    if (errors && (errors.Correo || errors.Password)) {
      setErrores({ ...errors });
      return false;
    }
    setLoading(true);
    const response = await login(frmValues);
    if (response) {
      var bs64 = btoa(unescape(encodeURIComponent(JSON.stringify(response))));
      sessionStorage.setItem(amb + '_User', bs64);
      getPerfil(data => {
        if (Object.keys(data).length > 0) {
          const perfil = data;
          localStorage.removeItem('foto');
          localStorage.setItem('foto', perfil.tabla2[0].foto !== "" ? perfil.tabla2[0].foto : process.env.PUBLIC_URL + "/images/default-avatar.png");
          fncPostula();
        } else {
          setLoading(false);
        }
      });
    } else {
      setLoading(false);
    }
  }

  return (
    <>
      <FormContainer left={true} active={active}>
        <div className="form">
          <Typography className="title">Iniciar sesion</Typography>
          <TextField
            error={errores.Correo}
            id="login-input"
            label="Correo electrónico"
            helperText={errores.Correo ? errores.Correo : " "}
            type="email"
            value={frmValues.Correo}
            onFocus={() => setErrores({ ...errores, Correo: "" })}
            onChange={(e) => setFrmValues({ ...frmValues, Correo: e.target.value })}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                submit()
              }
            }}
          />
          <TextField
            error={errores.Password}
            id="pass-input"
            label="Contraseña"
            helperText={errores.Password ? errores.Password : " "}
            type="password"
            value={frmValues.Password}
            onFocus={() => setErrores({ ...errores, Password: "" })}
            onChange={(e) => setFrmValues({ ...frmValues, Password: e.target.value })}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                submit()
              }
            }}
          />
          <Button size="small" className="btnOlvidaContrasenia" onClick={() => recuperarPassword()}>
            ¿Olvidaste tu contraseña?
          </Button>
          <LoadingButton loading={loading} variant="contained" color="primary" className="btnSubmit" onClick={() => submit()}>
            Hacer login y postular
          </LoadingButton>
          <Button className="btnMobile" variant="contained" onClick={() => fncMobile()}>
            Registrarme y postularme
          </Button>
        </div>
      </FormContainer>
    </>
  )
}

export default FrmLogin;